import './investment-portal-account-selector.scss';
import template from './investment-portal-account-selector.html';
import {AccountsService} from "../../Http/Accounts/AccountsService";
import {RegisterDefaultComponent} from "../../Common/componentsHelpers";
import {ComponentBase} from "../../Common/componentBase";

const accountsService = new AccountsService();
export class InvestmentPortalAccountSelector extends ComponentBase {

    constructor() {
        super();
        this.accounts = ko.observableArray([]);
        this.loader = ko.observable(false);
        this.goToInvestments = this.goToInvestments.bind(this);
        this.goToDevenirSite = this.goToDevenirSite.bind(this);
        this.isDevenir = ko.observable(false);
        const urlContainsDevenir = window.location.href.toLowerCase().includes("devenirinvestments");
        if (urlContainsDevenir) {
            this.isDevenir(true);
        }
        this.init = this.init.bind(this);
        this.error = ko.observable("");
        this.init();
    }

    goToDevenirSite(account) {
        const investmentPartnerSsoUrlRequest = new $.cdh.get.investments.getInvestmentPartnerSsoUrl(account.AccountId);
        investmentPartnerSsoUrlRequest.load()
            .done((url) => {
                window.open(url, '_self');
            })
            .fail((xhr) => {
                this.loader(false);
                document.getElementById("layoutContent").style.display = "";
                document.location.href = `/Page/InvestmentsForAccount?accountId=${account.AccountId}&isVeba=${account.IsVeba}`;
            });
    }


    async init() {
        this.loader(true);
        await this.apiInitCallAsync(async () => {
            try {
                var accounts = await accountsService.getListInvestmentAsync();
                if (this.isDevenir()) {
                    accounts = accounts.filter(account => account.InvestmentState === 3 || account.InvestmentState === 1);
                    if (accounts && accounts.length == 1) {
                        this.accounts(accounts);
                        this.loader(true);
                        await this.goToDevenirSite(accounts[0]);
                        return;
                    }
                }
                document.getElementById("layoutContent").style.display = "";
                this.accounts(accounts);
                this.loader(false);
                if (accounts.length === 1) {
                    accounts[0].InvestmentUrl = (accounts[0].InvestmentState === $.cdh.enums.investmentSolutionStates.activeDrive || accounts[0].InvestmentState === $.cdh.enums.investmentSolutionStates.inactiveDrive) ? `/Page/Investment/#/account/${accounts[0].AccountId}` : `/Page/InvestmentsForAccount?accountId=${accounts[0].AccountId}&isVeba=${accounts[0].IsVeba}`;
                    document.location.href = accounts[0].InvestmentUrl;
                }
            }
            catch (error) {
                document.getElementById("layoutContent").style.display = "";
                this.loader(false);
                this.error('Internal Server Error');
            }
        });
    }

    goToInvestments(account) {
        if (this.isDevenir() && account.InvestmentState == 3) {
            this.loader(true);
            this.goToDevenirSite(account);
        }
        else {
            if (account.InvestmentState === $.cdh.enums.investmentSolutionStates.activeDrive || account.InvestmentState === $.cdh.enums.investmentSolutionStates.inactiveDrive) {
                document.location.href = `/Page/Investment/#/account/${account.AccountId}`;
            } else {
                document.location.href = `/Page/InvestmentsForAccount?accountId=${account.AccountId}&isVeba=${account.IsVeba}`;
            }
        }
    }
}

RegisterDefaultComponent('investment-account-selector', template, InvestmentPortalAccountSelector);